// npm
import React from 'react'
import { Link } from "react-router-dom"
import {
   useQuery,
   useQueryClient,
 } from 'react-query'
import {
  MailIcon,
  PhoneIcon,
  LinkIcon,
  PhotographIcon,
  DocumentTextIcon,
} from '@heroicons/react/solid'

// local
import { getDomains } from '../api.js'

// components
import ContentLayout from '../components/ContentLayout.jsx'

const images = [
  'photo-1494790108377-be9c29b29330',
  'photo-1570295999919-56ceb5ecca61',
  'photo-1520813792240-56fc4a3765a7',
  'photo-1498551172505-8ee7ad69f235',
  'photo-1532417344469-368f9ae6d187',
  'photo-1566492031773-4f4e44671857',
  'photo-1534751516642-a1af1ef26a56',
  'photo-1488426862026-3ee34a7d66df',
  'photo-1506794778202-cad84cf45f1d',
  'photo-1601006986549-e028da30b614',
  'photo-1531384441138-2736e62e0919',
  'photo-1548142813-c348350df52b',
  'photo-1557053910-d9eadeed1c58',
  'photo-1554727242-741c14fa561c',
  'photo-1589156191108-c762ff4b96ab',
  'photo-1604093442026-2423d6b5dca6',
  'photo-1531853867013-ae14926dd6ea',
  'photo-1605992582137-6ee2730fff6d',
  'photo-1482555670981-4de159d8553b',
  'photo-1617370447481-f4691f05d6f1',
].map(id => `https://images.unsplash.com/${id}?auto=format&fit=facearea&facepad=2&w=256&h=256`)

function randomImageUrl() {
  return images[Math.floor(Math.random() * images.length)]
}

// From : https://tailwindui.com/components/application-ui/lists/grid-lists
function DomainGridSquare({ domain }) {
  return (
    <li key={domain.name} className="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
      <div className="w-full flex items-center justify-between p-6 space-x-6">
        <div className="flex-1 truncate">
          <div className="flex items-center space-x-3">
            <h3 className="text-gray-900 text-sm font-medium truncate">
              <Link to={ `/${domain.name}/` }>{domain.name}</Link>
            </h3>
            <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">
              { domain.role }
            </span>
          </div>
          <p className="mt-1 text-gray-500 text-sm truncate">{ domain.inserted }</p>
        </div>
        <img className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" src={ randomImageUrl() } alt="" />
      </div>
      <div>
        <div className="-mt-px flex divide-x divide-gray-200">
          <div className="w-0 flex-1 flex">
            <Link
              to={ `/${domain.name}/url/` }
              className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
            >
              <LinkIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
            </Link>
          </div>
          <div className="-ml-px w-0 flex-1 flex">
            <Link
              to={ `/${domain.name}/image/` }
              className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
            >
              <PhotographIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
            </Link>
          </div>
          <div className="-ml-px w-0 flex-1 flex">
            <Link
              to={ `/${domain.name}/text/` }
              className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
            >
              <DocumentTextIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </li>
  )
}

export default function Home() {
  // query for domains
  const queryClient = useQueryClient()
  const query = useQuery('domains', getDomains, { refetchOnWindowFocus: false })

  if (query.isLoading) {
    return <p>Loading...</p>
  }

  const domains = query.data
  console.log('domains:', domains)

  return (
    <ContentLayout title="Dashboard">
      <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        { domains.map(domain => <DomainGridSquare key={ domain.id  } domain={ domain } />)}
      </ul>
    </ContentLayout>
  )
}
